'use client';

import Link from 'next/link';
import React from 'react';

export interface IButton {
	type?: 'button' | 'submit' | 'reset';
	className?: string;
	href?: string;
	children?: React.ReactNode;
	onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
	endIcon?: React.ReactNode;
	variant?: 'contained' | 'outlined' | 'soft';
	ariaLabel?: string;
	fullWidth?: boolean;
	scrollTo?: string;
	startIcon?: React.ReactNode;
	color?: 'dark' | 'primary' | 'neutral';
	size?: 'small' | 'medium' | 'large';
	disabled?: boolean;
}

export default function Button(props: IButton) {
	const { variant = 'contained', color = 'primary', size = 'medium' } = props;

	const getBgColor = () => {
		switch (color) {
			case 'dark':
				return 'bg-primary-600';
			case 'neutral':
				return 'bg-neutral-50 !text-primary-500';
			default:
				return 'bg-white !text-primary-500 ';
		}
	};

	const getBgHoverColor = () => {
		switch (color) {
			case 'dark':
				return 'hover:bg-dark-neutral-800 border border-dark-neutral-600';
			case 'neutral':
				return 'hover:bg-neutral-100 border border-neutral-300';
			default:
				return 'hover:bg-transparent border-2 border-white  ';
		}
	};

	const getSize = () => {
		switch (size) {
			case 'small':
				return 'py-[6px] px-5 text-sm';
			case 'large':
				return 'py-3 px-6 text-sm';
			default:
				return 'py-[8px] px-6 text-md text-sm lg:text-base !font-bold tracking-widest';
		}
	};

	if (props.href) {
		return (
			<Link
				prefetch={false}
				href={`${props.href}`}
				className={`${!!props.className ? props.className : ''}`}
			>
				<button
					disabled={props.disabled}
					aria-label={!!props.ariaLabel?.length ? props.ariaLabel : undefined}
					type={props.type}
					onClick={(e) => {
						if (props.onClick) {
							props.onClick(e);
						}
					}}
					className={`${!!props.className ? props.className : ''} ${
						props.disabled && 'opacity-50 '
					} z-20 flex items-center justify-center font-semibold text-nowrap gap-2 uppercase relative rounded-full border-6 transition-all  shadow-cardImage hover:shadow-sm   ${
						props.fullWidth && 'w-full'
					}
					${variant === 'soft' && `bg-card text-primary-500 ${getSize()}`}
					${
						variant === 'contained' &&
						`${getBgColor()} ${getBgHoverColor()} ${getSize()} text-white ${
							color === 'primary' ? 'hover:!text-white' : ''
						}`
					}
					${
						variant === 'outlined' &&
						`${getBgColor()} ${
							color === 'dark' && variant === 'outlined'
								? '!border-primary-500  border-2 !text-primary-500 hover:!text-white hover:!bg-primary-500'
								: ''
						} !bg-transparent  hover:!text-black ${
							color === 'primary'
								? 'hover:!bg-white hover:!text-black !text-white'
								: ''
						} 
						${color === 'neutral' ? 'hover:!bg-white hover:!text-black !text-white' : ''}
						${getBgHoverColor()} ${getSize()} text-white`
					}
					`}
				>
					{props.startIcon}
					<p className="">{props.children}</p>
					{props.endIcon}
				</button>
			</Link>
		);
	} else {
		return (
			<>
				<button
					disabled={props.disabled}
					aria-label={!!props.ariaLabel?.length ? props.ariaLabel : undefined}
					type={props.type}
					onClick={(e) => {
						if (props.onClick) {
							props.onClick(e);
						}
					}}
					className={`${!!props.className ? props.className : ''} ${
						props.disabled && 'opacity-50 '
					} z-20 flex items-center justify-center font-semibold text-nowrap gap-2 uppercase relative rounded-full border-6 transition-all  shadow-cardImage hover:shadow-sm   ${
						props.fullWidth && 'w-full'
					}
					${variant === 'soft' && `bg-card text-primary-500 ${getSize()}`}
					${
						variant === 'contained' &&
						`${getBgColor()} ${getBgHoverColor()} ${getSize()} text-white ${
							color === 'primary' ? 'hover:!text-white' : ''
						}`
					}
					${
						variant === 'outlined' &&
						`${getBgColor()} ${
							color === 'dark' && variant === 'outlined'
								? `!border-primary-500  border-2 !text-primary-500 ${
										!props.disabled
											? 'hover:!text-white hover:!bg-primary-500'
											: ''
								  }  `
								: ''
						} !bg-transparent ${!props.disabled ? 'hover:!text-black' : ''}  ${
							color === 'primary'
								? 'hover:!bg-white hover:!text-black !text-white'
								: ''
						} 
						${color === 'neutral' ? 'hover:!bg-white hover:!text-black !text-white' : ''}
						${getBgHoverColor()} ${getSize()} text-white`
					}
					`}
				>
					{props.startIcon}
					<p className="">{props.children}</p>
					{props.endIcon}
				</button>
			</>
		);
	}
}
